const SortDirectionEnum = {
  Ascending : 'Ascending',
  Descending: 'Descending'
}

export default SortDirectionEnum
